import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";
import { track } from "@/lib/analytics";

export default function WhatsAppFloat() {
  return (
    <a
      data-testid="wa-float"
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => track("whatsapp_click", { source: "float" })}
      aria-label="Falar no WhatsApp"
      className="wa-pulse fixed bottom-6 right-6 z-50 h-14 w-14 sm:h-16 sm:w-16 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white flex items-center justify-center shadow-2xl transition-transform hover:scale-110"
    >
      <MessageCircle size={28} strokeWidth={2.3} />
    </a>
  );
}
